import { Coolwhip } from '@circlefin/components'
import { Footer, HeaderPublic } from '@containers/layout'
import { GoogleTagManager } from '@containers/services'
import { Main } from '@shared/components/layout'
import { BaseLayout } from '@shared/layout/core'
import classNames from 'classnames'

import type { AppLayoutType } from '@shared/layout/core'

export interface GetStartedLayoutProps {
  /**
   * Center content within the main tag.
   */
  centerContent?: boolean
  /**
   * No padding around main content.
   */
  noPadding?: boolean
}

export const GetStartedLayout: AppLayoutType<GetStartedLayoutProps> = ({
  children,
  centerContent = true,
  noPadding = false,
}) => {
  return (
    <BaseLayout className="grid-rows-[min-content_auto_min-content]">
      <GoogleTagManager />
      <div>
        <HeaderPublic>
          <HeaderPublic.Logo align="center" variant="mobile-full" />
          <HeaderPublic.SignIn className="hidden sm:block" />
          <HeaderPublic.LogOut />
        </HeaderPublic>
        <div className="h-0.5 w-full bg-black-75" />
      </div>
      <Coolwhip
        className="fixed bottom-0 h-screen w-full translate-y-56 opacity-0 md:opacity-100"
        variant="fade-top/green-blue-violet"
      />
      <Main
        className={classNames(
          'relative overflow-y-auto h-full',
          { 'mx-auto': centerContent },
          { 'px-6 py-12 md:px-4 md:pt-18': !noPadding },
        )}
      >
        {children}
      </Main>
      <Footer />
    </BaseLayout>
  )
}
